import { createContext } from 'react';

/**
 * When true, `Card` and `SectionCard` render their children without the card
 * chrome (no box, shadow or title row). `SectionEditDrawer` sets it so a
 * profile section's existing edit-mode markup can sit inside the side panel,
 * whose own header already carries the title - without every section
 * component growing a "bare" prop (profile-redesign 02-design §5).
 */
export const CardBareContext = createContext(false);
